import { useEffect, useState } from 'react';

// @mui material components
import { Tab, Tabs, Grid, Card } from '@mui/material';

// Material Dashboard 2 React components
import MDBox from 'components/MDBox';

import TabPanel from 'components/TabPanel/TabPanel';

import PropertyReportsTab from './components/PropertyReportsTab';
import { useLocation, useNavigate } from 'react-router-dom';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const PropertyReports = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [value, setValue] = useState('most-liked');

  const handleChange = (event, newValue) => {
    handleTabSelect(newValue);
  };

  const handleTabSelect = (tabKey) => {
    switch (tabKey) {
      case 'most-liked':
        navigate(
          {
            hash: 'most-liked',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      case 'most-appreciated':
        navigate(
          {
            hash: 'most-appreciated',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      case 'most-traded':
        navigate(
          {
            hash: 'most-traded',
          },
          { replace: true }
        );
        setValue(tabKey);
        break;

      default:
        navigate(
          {
            hash: 'most-liked',
          },
          { replace: true }
        );
        setValue('most-liked');
        break;
    }
  };

  useEffect(() => {
    if (location.hash === '') {
      navigate(
        {
          hash: 'most-liked',
        },
        { replace: true }
      );
    } else {
      handleTabSelect(location.hash?.replace('#', ''));
    }
  }, [location.hash]);

  return (
    <MDBox pt={6} pb={3}>
      <Grid container spacing={6}>
        <Grid item xs={12}>
          <Card>
            <MDBox>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="Users Reports"
              >
                <Tab
                  value={'most-liked'}
                  label="Most Liked Properties"
                  {...a11yProps(0)}
                />
                <Tab
                  value={'most-appreciated'}
                  label="Most Appreciated Properties"
                  {...a11yProps(1)}
                />
                <Tab
                  value={'most-traded'}
                  label="Most Traded Properties"
                  {...a11yProps(2)}
                />
              </Tabs>
            </MDBox>
            <TabPanel value={value} index={'most-liked'}>
              <PropertyReportsTab reportType={'most-liked'} />
            </TabPanel>

            <TabPanel value={value} index={'most-appreciated'}>
              <PropertyReportsTab reportType={'most-appreciated'} />
            </TabPanel>

            <TabPanel value={value} index={'most-traded'}>
              <PropertyReportsTab reportType={'most-traded'} />
            </TabPanel>
          </Card>
        </Grid>
      </Grid>
    </MDBox>
  );
};

export default PropertyReports;
